// Single source of truth for branding. Change the name here and it updates everywhere in the app.
export const BRAND = {
  name: "ESL AI Lesson Adaptation Studio",
  mark: "ESL AI", // bold part of the wordmark
  rest: "Lesson Adaptation Studio", // lighter part (hidden on narrow phones)
  copyright:
    "COPYRIGHT  ©  2026   MELINA WONG.  SPECIALLY DESIGNED & CREATED USING KIOZK™  (KIOZK™  CLOUD)  BY  THE SOFTWARE SUITE™  AND  A.J. HAKIMI.   ALL RIGHTS RESERVED.",
  emails: ["support@esl-studio.world", "info@esl-studio.world"],
  handbookUrl: "https://www.amazon.com/ESL-TEACHERS-HANDBOOK-Ready-Use/dp/B0HL3XLRZR",
} as const;

export const pageTitle = (page?: string) => (page ? `${page} — ${BRAND.name}` : BRAND.name);
